import React from 'react'

import './categories.scss'
import { CategorieHeader } from './components/CategorieHeader/CategorieHeader'
import { SeeAllCategorie } from './components/SeeAllCategorie/SeeAllCategorie'
import { Subcategorie } from './components/Subcategorie/Subcategorie'

interface CategoriesProps {
  categories?: {
    title: string
    slug: string
    subcategorie: {
      title: string
      slug: string
    }[]
  }[]
  departamentSlug?: string
  closeMenu: () => void
  currentCategorie: string
  setCurrentCategorie: (currentCategorie: string) => void
  subCategoriePosition: number
  setSubCategoriePosition: (postion: number) => void
}
const Categories = ({
  categories,
  departamentSlug = '',
  closeMenu,
  currentCategorie,
  setCurrentCategorie,
  setSubCategoriePosition,
  subCategoriePosition,
}: CategoriesProps) => {
  if (!categories) {
    return null
  }

  return (
    <>
      {categories?.map((categorie) => {
        return (
          <div
            key={categorie?.title}
            className=" desktop-menu-categories-container"
          >
            <CategorieHeader
              subcategorie={categorie?.subcategorie}
              categorieSlug={categorie?.slug}
              categorieTitle={categorie?.title}
              departamentSlug={departamentSlug}
              closeMenu={closeMenu}
              setCurrentCategorie={setCurrentCategorie}
              currentCategorie={currentCategorie}
            />
            <Subcategorie
              categorieSlug={categorie?.slug}
              categorieTitle={categorie?.title}
              closeMenu={closeMenu}
              currentCategorie={currentCategorie}
              departamentSlug={departamentSlug}
              setCurrentCategorie={setCurrentCategorie}
              setSubCategoriePosition={setSubCategoriePosition}
              subCategoriePosition={subCategoriePosition}
              subcategorie={categorie?.subcategorie}
            />
            <SeeAllCategorie
              categorieTitle={categorie?.title}
              categorieSlug={categorie?.slug}
              departamentSlug={departamentSlug}
              closeMenu={closeMenu}
              validation={categorie?.subcategorie?.length > 3}
              setCurrentCategorie={setCurrentCategorie}
            />
          </div>
        )
      })}
    </>
  )
}

export default Categories
